import { render, staticRenderFns } from "./UserAcces.vue?vue&type=template&id=a8d7bee2&"
import script from "./UserAcces.vue?vue&type=script&lang=js&"
export * from "./UserAcces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports